import React from 'react';

const GreyBackground = ({ children }) => {
     return (
          <div className='grey-bg'>{ children }</div>
     )
};

export default GreyBackground;